import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useHttpClient } from "../hooks/http-hook";
import { useParams } from "react-router-dom";
import Display from "../Components/ManageProgram/Display";
import ManageModules from "../Components/ManageModules/ManageModules";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function ManageProgram() {
  const { sendRequest } = useHttpClient();
  const { id } = useParams();
  const [program, setProgram] = useState(null);
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const response = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + `/programs/${id}`
        );
        setProgram(response.program);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProgram();
  }, [id, sendRequest]);

  return (
    <div>
      <Tabs
        variant="underline"
        defaultActiveKey="display"
        id="manage-program-tabs"
        className="justify-content-center"
      >
        <Tab eventKey="display" title={t("display_tab")}>
          <Display program={program} />
        </Tab>
        <Tab eventKey="Modules" title={t("modules_tab")}>
          <ManageModules program={program} />
        </Tab>
      </Tabs>
    </div>
  );
}

export default ManageProgram;
